<template>
  <form class="form-horizontal">
    <div class="form-group" v-if="operator.id">
      <label class="col-sm-2 control-label">Регистрационный номер:</label>
      <label class="col-sm-10 control-label">
        <span class="pull-left">{{operator.id}}</span>
      </label>
    </div>
    <div class="form-group" :class="{'has-error' : errors.has('operator.region')}">
      <label class="col-sm-2 control-label"><b>Субъект РФ*:</b></label>
      <div class="col-sm-10">
        <v-select :options="regions" v-model="operator.region" label="name"
                  name="operator.region" class="select2"
                  v-validate data-vv-rules="required" data-vv-as="Субъект РФ">
        </v-select>
        <span v-show="errors.has('operator.region')"
              class="text-danger">{{ errors.first('operator.region') }}</span>
      </div>
    </div>
    <div class="form-group" :class="{'has-error' : errors.has('operator.name')}">
      <label class="col-sm-2 control-label"><b>Полное название организации*:</b></label>
      <div class="col-sm-10">
        <input v-validate="'required|max:768'" class="form-control"
               data-vv-as="Полное название организации"
               :class="{'input': true, 'is-danger': errors.has('operator.name')}"
               name="operator.name"
               type="text" placeholder="Полное название организации" v-model="operator.name" autocomplete="off">
        <span v-show="errors.has('operator.name')" class="text-danger">{{ errors.first('operator.name') }}</span>
      </div>
    </div>

    <div class="form-group" :class="{'has-error' : errors.has('operator.legalEntityForm')}">
      <label class="col-sm-2 control-label">Форма организации юридического лица:</label>
      <div class="col-sm-10">
        <v-select :options="legalEntityForms" v-model="operator.legal_entity_form" label="name"
                  name="operator.legalEntityForm" class="select2"
                  v-validate data-vv-rules="" data-vv-as="Форма организации юридического лица">
        </v-select>
        <span v-show="errors.has('operator.legalEntityForm')"
              class="text-danger">{{ errors.first('operator.legalEntityForm') }}</span>
      </div>
    </div>

    <div class="form-group" :class="{'has-error' : errors.has('operator.inn')}">
      <label class="col-sm-2 control-label"><b>ИНН*:</b></label>
      <div class="col-sm-10">
        <input v-validate="'required|numeric'" class="form-control"
               data-vv-as="ИНН"
               :class="{'input': true, 'is-danger': errors.has('operator.inn')}"
               name="operator.inn"
               type="text" placeholder="ИНН" v-model="operator.inn" autocomplete="off">
        <span v-show="errors.has('operator.inn')" class="text-danger">{{ errors.first('operator.inn') }}</span>
      </div>
    </div>

    <div class="form-group" :class="{'has-error' : errors.has('operator.kpp')}">
      <label class="col-sm-2 control-label">КПП:</label>
      <div class="col-sm-10">
        <input v-validate="'numeric'" class="form-control"
               data-vv-as="КПП"
               :class="{'input': true, 'is-danger': errors.has('operator.kpp')}"
               name="operator.kpp"
               type="text" placeholder="КПП" v-model="operator.kpp" autocomplete="off">
        <span v-show="errors.has('operator.kpp')" class="text-danger">{{ errors.first('operator.kpp') }}</span>
      </div>
    </div>

    <div class="form-group" :class="{'has-error' : errors.has('operator.ogrn')}">
      <label class="col-sm-2 control-label"><b>ОГРН*:</b></label>
      <div class="col-sm-10">
        <input v-validate="'required'" class="form-control"
               data-vv-as="ОГРН"
               :class="{'input': true, 'is-danger': errors.has('operator.ogrn')}"
               name="operator.ogrn"
               type="text" placeholder="ОГРН" v-model="operator.ogrn" autocomplete="off">
        <span v-show="errors.has('operator.ogrn')" class="text-danger">{{ errors.first('operator.ogrn') }}</span>
      </div>
    </div>

    <div class="form-group" :class="{'has-error' : errors.has('operator.okved')}">
      <label class="col-sm-2 control-label"><b>Вид экономической деятельности (по ОКВЭД)*:</b></label>
      <div class="col-sm-10">
        <input v-validate="'required'" class="form-control"
               data-vv-as="Вид экономической деятельности (по ОКВЭД)"
               :class="{'input': true, 'is-danger': errors.has('operator.okved')}"
               name="operator.okved"
               type="text" placeholder="Вид экономической деятельности (по ОКВЭД)" v-model="operator.okved"
               autocomplete="off">
        <span v-show="errors.has('operator.okved')" class="text-danger">{{ errors.first('operator.okved') }}</span>
      </div>
    </div>

    <div class="form-group" :class="{'has-error' : errors.has('operator.address')}">
      <label class="col-sm-2 control-label"><b>Фактический адрес нахождения*:</b></label>
      <div class="col-sm-10">
        <input v-validate="'required|max:512'" class="form-control"
               data-vv-as="Фактический адрес нахождения"
               :class="{'input': true, 'is-danger': errors.has('operator.address')}"
               name="operator.address"
               type="text" placeholder="Фактический адрес нахождения" v-model="operator.address" autocomplete="off">
        <span v-show="errors.has('operator.address')" class="text-danger">{{ errors.first('operator.address') }}</span>
      </div>
    </div>
    <div class="form-group" :class="{'has-error' : errors.has('operator.city')}">
      <label class="col-sm-2 control-label"><b>Город (Населенный пункт)*:</b></label>
      <div class="col-sm-10">
        <v-select :options="cities" v-model="operator.city" label="operator_city"
                  name="operator.city" class="select2"
                  v-validate="'required'" data-vv-rules="" data-vv-as="Город">
        </v-select>
        <span v-show="errors.has('operator.city')" class="text-danger">{{ errors.first('operator.city') }}</span>
      </div>
    </div>
    <div class="form-group" :class="{'has-error' : errors.has('operator.type')}">
      <label class="col-sm-2 control-label"><b>Система размещения*:</b></label>
      <div class="col-sm-10">
        <v-select :options="operatorTypes" v-model="operator.type" label="name"
                  name="operator.type" class="select2"
                  v-validate data-vv-rules="required" data-vv-as="Система размещения">
        </v-select>
        <span v-show="errors.has('operator.type')"
              class="text-danger">{{ errors.first('operator.type') }}</span>
      </div>
    </div>
  </form>
</template>

<script>
  import axios from 'axios'
  import {mapGetters} from 'vuex'

  export default {
    props: [
      'operator'
    ],
    data: function () {
      return {
        cities: ['Ессентуки', 'Железноводск', 'Кисловодск', 'Пятигорск']
      }
    },
    created: function () {
      this.updateFieldValue()
    },
    computed: {
      ...mapGetters(
        {
          operatorTypes: 'operatorTypes',
          legalEntityForms: 'legalEntityForms',
          regions: 'regions',
          privilegeCategories: 'privilegeCategories'
        }
      )
    },
    methods: {
      updateFieldValue: function () {
        if (this.operator.legal_entity_form) {
          this.operator.legal_entity_form = this.legalEntityForms.find(item => item.id === this.operator.legal_entity_form)
        }
        if (this.operator.region) {
          this.operator.region = this.regions.find(item => item.id === this.operator.region)
        }
        if (this.operator.type) {
          this.operator.type = this.operatorTypes.find(item => item.id === this.operator.type)
        }
      },
      validate: function () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$emit('dataIsValid')
          } else {
            this.$snotify.warning('Проверьте введенные данные!', 'Ошибка!')
          }
        })
      },
      getDictById: function (dictName, id) {
        return dictName.find(item => item.id === id)
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/operators/OperatorForm.vue